const REQUEST_URL = process.env.REACT_APP_REQUEST_URL;

export const urls = {
  createRequest: () => `${REQUEST_URL}/transportgroup/create`,
  getAllRequests: () => `${REQUEST_URL}/transportgroup/history`
};
